import * as React from 'react';
import {Backdrop as MuiBackdrop, CircularProgress, Stack} from '@mui/material';

type BackdropProps = {
    open: boolean,
    text?: string,
    full?: boolean
}

const BackDrop = (props: BackdropProps): any => {
    const {open, text, full} = props;

    return (
        <div>
            <MuiBackdrop
                sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + (full ? 999999 : 99999)}}
                open={open}
            >
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                >
                    <CircularProgress color="inherit" sx={{mb: 1}}/>

                    <span>{text && text}</span>
                </Stack>
                
            </MuiBackdrop>
        </div>
    );
}

export default BackDrop;
